// @ts-nocheck
/**
 * Sidebar "Support" (staff Inbox) item content, matching the sidebar's own pattern:
 *   - COLLAPSED: headset icon (+ a small gear to mark the staff side) on top and the
 *     "Support" label below — same 50x50 wrapper/label the other items use.
 *   - EXPANDED: plain "Support" text (no symbol), like the other expanded items.
 * A badge shows OPEN human tickets = total open MINUS the ones still with the AI
 * (all − IA). Self-fetches openCounts and refreshes live via Socket.IO.
 */
import React, { useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";
import SupportAgentIcon from "@mui/icons-material/SupportAgent";
import SettingsIcon from "@mui/icons-material/Settings";
import { socket } from "../../services/socket.io/socket.io.config";
import { fetchSupportOpenCounts } from "../../api/support";

export default function SupportInboxMenuIcon({ open, active }) {
  const [count, setCount] = useState(0);

  useEffect(() => {
    const load = async () => {
      const { response } = await fetchSupportOpenCounts();
      const total = response?.data?.total || 0;
      const ia = response?.data?.byCategory?.ia || 0;
      setCount(Math.max(0, total - ia));
    };
    load();
    const onChanged = () => load();
    socket.on("support_changed", onChanged);
    return () => socket.off("support_changed", onChanged);
  }, []);

  const color = active ? "#d175b6" : "#ffffff";

  // EXPANDED: just the label (no symbol), like the other menu items; keep a small
  // count so the agent still sees pending tickets.
  if (open) {
    return (
      <Box component="span" sx={{ display: "inline-flex", alignItems: "center", gap: 1 }}>
        <span>Support</span>
        {count > 0 ? (
          <Box
            component="span"
            sx={{
              bgcolor: "#e53935",
              color: "#fff",
              borderRadius: "10px",
              fontSize: 11,
              lineHeight: 1,
              minWidth: 18,
              height: 18,
              px: 0.6,
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            {count}
          </Box>
        ) : null}
      </Box>
    );
  }

  // COLLAPSED: mirror IconWithLabel — icon (50x50) on top, label below.
  return (
    <Box className="main-icon-label-wrapper" sx={{ position: "relative" }}>
      <Box className={`icon-wrapper ${active ? "active" : ""}`} width={50} height={50}>
        <Box className="icon-container">
          <Box sx={{ position: "relative", display: "inline-flex" }}>
            <SupportAgentIcon sx={{ color, fontSize: 40 }} />
            <SettingsIcon
              sx={{
                position: "absolute",
                right: -3,
                bottom: -3,
                fontSize: 15,
                color,
                bgcolor: "#0b0b10",
                borderRadius: "50%",
              }}
            />
          </Box>
        </Box>
      </Box>
      <Typography className="icon-label">Support</Typography>
      {count > 0 ? (
        <Box
          sx={{
            position: "absolute",
            top: -2,
            left: "calc(50% + 10px)",
            bgcolor: "#e53935",
            color: "#fff",
            borderRadius: "10px",
            fontSize: 10,
            lineHeight: 1,
            minWidth: 17,
            height: 17,
            px: 0.5,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 2,
          }}
        >
          {count}
        </Box>
      ) : null}
    </Box>
  );
}
